import { gql } from '@apollo/client';

export const APPLY_BULK_ACTIONS_TO_PRICE_CHANGE_REQUESTS = gql(/* GraphQL */ `
    mutation ApplyBulkActionsToPriceChangeRequests(
        $input: BulkApplyPriceChangeRequestsInput!
    ) {
        applyBulkActionsToPriceChangeRequests(input: $input) {
            appliedCount
            failures {
                priceChangeRequestId
                message
            }
        }
    }
`);

export const ACTION_PRICE_CHANGE_REQUEST = gql(/* GraphQL */ `
    mutation ActionPriceChangeRequest($input: ApplyActionDto!) {
        applyActionToPriceChangeRequest(input: $input) {
            id
        }
    }
`);

export default ACTION_PRICE_CHANGE_REQUEST;
